import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [schema, setSchema] = useState(null);

  const reload = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) return;
    if (!localStorage.getItem("lx_token")) return setMe(false);
    try {
      const [m, s] = await Promise.all([api.get("/auth/me"), api.get("/schema")]);
      setMe(m.data);
      setSchema(s.data);
    } catch {
      setMe(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const signIn = async (data) => {
    localStorage.setItem("lx_token", data.access_token);
    localStorage.removeItem("lx_org");
    window.history.replaceState(null, "", window.location.pathname);
    await reload();
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("lx_token");
    localStorage.removeItem("lx_org");
    setMe(false);
  };
  const can = (module, action = "read") => {
    if (!me) return false;
    if (me.is_super_admin) return true;
    const p = me.permissions?.[module] || "";
    return action === "write" ? p.includes("w") : p.includes("r");
  };

  return <AuthCtx.Provider value={{ me, schema, reload, signIn, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
